import * as Yup from "yup";


export const loginValidationSchema = Yup.object().shape({
    email: Yup.string().email('Enter valid email address').required("Email ID is required"),
    // email: Yup.string().trim().required("Email is required"),
    password: Yup.string()
    .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, 'Password should have at least eight characters, at least one letter, one number')
    .required("Password is required")
  });